export const OnBoardingNumber = ({ number }: { number: number }) => (
  <div className="absolute flex items-center justify-center w-10 h-10 text-2xl font-bold text-white border rounded-full bg-gradient-side-bar">
    {number}
  </div>
);
